/* eslint-disable class-methods-use-this, no-undef */
/**
 * @note must enable no-undef eslint rule
 * had to turn it off cause lint is throwing
 *    'NodeListOf' is not defined no-undef
 * fix: need to set the TS target compiler option
 * to es6 or higher for NodeListOf
 */
import { TailwindPageBehavior } from './TailwindPageBehavior';
import { trackFormSuccess } from '../utils/analytics';

const doc = document;

export class HomePageBehavior extends TailwindPageBehavior {
  private zipCodeValidationRegex = this.gon.zipCodeValidationRegex || '^\\d{5}$';

  /**
   * add Hero form behavior
   */
  public heroFormBehavior() {
    const { heroForm } = this.cached;

    heroForm.addEventListener(
      'blur',
      (event) => {
        if (event.target instanceof HTMLInputElement) {
          const element = event.target;
          if (element.classList.contains('required')) {
            const submitBtnElement =
              element.parentElement.nextElementSibling.firstElementChild;
            if (
              element.value &&
              new RegExp(this.zipCodeValidationRegex, 'i').test((element.value).trim())
            ) {
              element.nextElementSibling.classList.add('hidden');
              element.classList.remove('border-red-500');
              submitBtnElement.classList.remove('cursor-not-allowed');
              submitBtnElement.removeAttribute('disabled');
            } else {
              element.nextElementSibling.classList.remove('hidden');
              element.classList.add('border-red-500');
              submitBtnElement.classList.add('cursor-not-allowed');
              submitBtnElement.setAttribute('disabled', 'disabled');
            }
          }
        }
      },
      true
    );

    heroForm.addEventListener('submit', (event) => {
      event.preventDefault();

      fetch('/city_page_lookup', {
        method: 'POST',
        headers: {
          'data-type': 'json',
          'Content-Type': 'application/json',
          'x-csrf-token': (doc.querySelector('meta[name="csrf-token"]') as any)
            .content,
        },
        body: this.formPayload,
      })
        .then(async (response) => {
          const parsedData = await response.json();
          if (response.ok) {
            this.heroFormGenericSuccess(parsedData);
          } else {
            throw new Error(response.statusText);
          }
        })
        .catch((error) => {
          if (this.gon.allowSignupNonLaunchedZips) {
            window.location.href = `${this.gon.currentHost}/role/full-service`;
          } else {
            super.heroFormGenericError(error.message);
          }
        });
    });
  }

  protected get formPayload() {
    const {
      heroFormFields: { zipCode },
    } = this.cached;
    return JSON.stringify({
      zip: zipCode.value,
    });
  }

  protected heroFormGenericSuccess({
    city_page_url: cityPageUrl,
    state,
  }: {
    city_page_url: string;
    state: string;
  }) {
    const {
      heroFormFields: { zipCode },
    } = this.cached;
    trackFormSuccess({
      source_type: 'address_check_form_submit',
      source: {
        zipcode: zipCode.value,
      },
      step_value: 'zipcode',
    });
    const queryParams = window.location.search;
    const delimiter = queryParams.includes('?') ? '&' : '?';
    window.location.href = `${cityPageUrl}${queryParams}${delimiter}zip=${zipCode.value}&state=${state}`;
  }
}
